<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12 row mb-2">
          <!-- <h5 class="col-12 col-sm-3 ">
            Quantidade de OS por nível 
          </h5> -->
          <!-- <button class="col-12 col-sm-2 btnLimparFiltro" @click="refreshPage()"><i class="fa fa-undo"></i>
            Atualizar
          </button> -->
        </div>

        <div class="col-md-3 col-sm-6 col-12 " v-for="(item, index) in mediaLiberacao" :key="index">
          <button @click="applyFilters(item.nr_nivel)" class="alert alert-danger text-capitalize cardIndicador"
            style="border-radius: 25px" :class="indicadorBg(index)" :style="indicadorBg(index)">
            <div class="row">
              <div class="col-8 text-transform-capitalize">
                {{ item | criticidade }}
              </div>
              <div class="col-4 text-right  text-lowercase">
                <strong>{{ Object.keys(item.ordem_servico).length  }}</strong>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)

export default {
  props: {
    filtrosProps: {}
  },
  data() {
    return {
      items: [
        {
          ds_criticidade: 'IMEDIATA'.toLowerCase(),
          tempo_medio: '2d 1h 25min'
        },
        {
          ds_criticidade: '24 HORAS'.toLowerCase(),
          tempo_medio: '2d 1h 25min'
        },
        {
          ds_criticidade: '48 HORAS'.toLowerCase(),
          tempo_medio: '2d 1h 25min'
        },
        { ds_criticidade: '30 DIAS'.toLowerCase(), tempo_medio: '2d 1h 25min' }
      ]
    }
  },

  mounted() {
    this.$store.dispatch('os/fetchMediaLiberacaoArmazem', { st_origem: 'I', filial: this.$root.filial.nr_sequencial })
  },

  computed: {
    filtros() {
      return this.$store.getters['os/filters']
    },

    internalFilters() {
      return { ...this.filtros }
    },

    mediaLiberacao() {
      const media = this.$store.getters['os/mediaLiberacaoArmazem']

      if (!media) return null

      const mappedMedia = media.map(item => {
        item.tempoFormatado = this.getTempoFormatado(item)

        return item
      })

      return mappedMedia
    }
  },

  methods: {
    refreshPage() {
      location.reload()
    },
    applyFilters(nr_nivel) {

      this.internalFilters.nr_nivel = nr_nivel
      const checkFiltro = this.$store.getters['os/getCheckSaveFilter']

      this.internalFilters.nr_nivel = nr_nivel

      this.internalFilters.checkSaveFilter = checkFiltro

      let filters = { ...this.internalFilters }

      this.$store.commit('os/setFilters', { filters: filters })
      this.updateFilters()
      document.getElementById('btnFiltro').click()
      localStorage.setItem('filtrosArmazem', JSON.stringify(filters));
    },
    updateFilters(newFilters) {
      this.$store.dispatch('os/reset')
      this.fetchItemsFromApi()
    },
    fetchItemsFromApi() {
      this.$store.dispatch('os/fetchFromApiArmazem')
    },
    indicadorBg(index) {
      switch (parseInt(index)) {
        case 0:
          // IMEDIATA
          return 'background-image: linear-gradient(45deg, #8f2326, #f03035) !important;'
        case 1:
          // EMERGENCIAL
          return 'background-image: linear-gradient(45deg, #b14e00, #f38833) !important;'
        case 2:
          // 24 HORAS
          return 'background-image: linear-gradient(45deg, #bd8e00, #fbc110) !important;'
        case 3:
          // 4 HORAS (HORÁRIO COMERCIAL)
          return 'background-image: linear-gradient(45deg, #028b4c, #00a65a) !important;'
        case 4:
          // 48 HORAS
          return 'background-image: linear-gradient(45deg, #00aff1, #00aff1);'

        default:
          return 'background-image: linear-gradient(45deg, rgb(128 128 128), rgb(202 202 202)) !important;'
      }
    },
    getTempoFormatado(media) {
      if (!media.ordem_servico.length) return null

      return moment.duration(parseInt(media.ordem_servico[0].media_horas_liberacao), 'seconds')
        .format('d[d] h[h]mm[m]', {
          userLocale: 'pt-BR'
        })
    }
  } 
}
</script>
<style scoped>
.cardIndicador {
  color: #fff !important;
  text-align: left;
  width: 100%;
}

.btnLimparFiltro {
  background: transparent;
  border: 1px solid #c9c9c9;
  margin-left: 13px;
}
</style>